
var SibApiV3Sdk = require('sib-api-v3-sdk');

export const getContactsList = async  (email, phone, isNew,  profil, news) =>{
    var defaultClient = SibApiV3Sdk.ApiClient.instance;

    // Configure API key authorization: api-key
    var apiKey = defaultClient.authentications['api-key'];
    apiKey.apiKey = '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';
    
    var apiInstance = new SibApiV3Sdk.ContactsApi();
      apiInstance.getContactInfo(email).then((data) => {

          var user = data;
          user.attributes.PROFIL_GUSTATIF = profil
          var identifier = user.email; // String | Email (urlencoded) OR ID of the contact
          var updateContact = new SibApiV3Sdk.UpdateContact(user);
          updateContact.attributes = user.attributes

          apiInstance.updateContact(identifier, updateContact).then(() => {
              console.log("Done !");
            }, function(error) {
              console.error(error);
            });

        }, function(error) {
          console.error(error);
        });
}


export const createContact =  async  (email, phone, news) =>{
  if(email.length > 0){
    var defaultClient = SibApiV3Sdk.ApiClient.instance;
    // Configure API key authorization: api-key
    var apiKey = defaultClient.authentications['api-key'];
    apiKey.apiKey = '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';
    var apiInstance = new SibApiV3Sdk.ContactsApi();
    var createContact = new SibApiV3Sdk.CreateContact(); // CreateContact | Values to create a contact
    createContact.email = email
    if(phone.length > 0){
      createContact.attributes = {"SMS":"+33"+phone.substring(1)}
    }
    if (news) {
      createContact.listIds = [2]
    }
    apiInstance.createContact(createContact).then((res) => {
      console.log("Done !")
    }, function() {

      apiInstance.getContactInfo(email).then((data) => {

        var user = data;
        var identifier = user.email; // String | Email (urlencoded) OR ID of the contact
        if(phone.length > 0){
          user.attributes.SMS = "+33"+phone.substring(1)
        }
        if(news &&  user.listIds.indexOf(2)===-1){
          user.listIds = user.listIds.concat(2)
        }
        console.log(user)
        var updateContact = new SibApiV3Sdk.UpdateContact(user);
        updateContact.attributes = user.attributes
        updateContact.listIds = user.listIds
        apiInstance.updateContact(identifier, updateContact).then(() => {
            console.log("Done !");
          }, function(error) {
            console.error(error);
          });

      }, function(error) {
        console.error(error);
      });
    });
  }
}
// export default {getContactsList, createContact}